<script setup lang="ts">
const i18nHead = useLocaleHead()
const { ogImage, favicon, title, description } = useHeaderInformation()

useHead({
  title,
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs.lang,
  },
  link: [
    ...(i18nHead.value.link || []),
    { rel: 'icon', href: favicon, id: 'favicon' },
  ],
  meta: [
    ...(i18nHead.value.meta || []),
    { property: 'og:title', content: title.value },
    { property: 'description', content: description.value },
    { property: 'og:description', content: description.value },
    { property: 'og:image', content: ogImage },
    { property: 'twitter:card', content: 'summary_large_image' },
  ],
})
</script>

<template>
  <v-app class="layout--background">
    <v-main>
      <v-container class="h-100" fluid>
        <LayoutRegisterHeader />
        <slot />
      </v-container>
    </v-main>
    <AppSnackbar />
  </v-app>
</template>

<style>
.layout--background {
  background: linear-gradient(
    to bottom,
    #fcd6e7 0%,
    #fdeef6 20%,
    #fdeef6 80%,
    #fbc8da 100%
  );
}
</style>
